import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
  export default {
    components: {
    },
    data() {
      return {
        ShowLoader: false,
        RoleData: "",
        RowId:0,
        RoleHeading:"",
        Permissions:""
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + ' - User Permissions';
      this.RowId = this.$route.params.RowId;
      this.GetRoles();
    },
    methods: {
      GetRoles() {
        Axios.post(Endpoints.Roles.Get,  {
          token: localStorage.getItem("token"),
          id: this.RowId,
        }).then((Response) => {
          if (Response?.data?.success) {
            this.RoleData = Response.data.record;
            this.RoleHeading = this.RoleData.title;
            this.Permissions = this.RoleData.permissions;
          }
        });
      },
    },
  };